import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const TravelAgent = () => (
  <Page {...seo.travelAgent}>
    <h2 className="mt-0 pt-0">TRAVEL AGENTS</h2>
    <p className="mb-1">Hello and Namaste,</p>
    <p>
      Whether you are a single person travel company or a two thousand strong global giant,
      you will still need friends in high places. ;) HoneyGuide can help you make really
      good friends in the mountains!
    </p>
    <p>
      Through HoneyGuide, you will be able to:
      <ol>
        <li>
          Focus more on the satisfaction and experience of the trekkers while still
          maintaining a very Lean Ground Operation.
        </li>
        <li>
          Ensure that your clients get the Best Service from local service providers, as
          HoneyGuide is loved and respected for providing a direct platform for Local
          Service Providers.
        </li>
        <li>
          Be fully assured that the prices quoted for the services are actually being
          delivered to the Local Service Providers.
        </li>
        <li>
          Help your clients no matter what happens as HoneyGuide is backed by Himalayan
          Expeditions, one of the largest Trek Operator in Nepal with 30 years of experience
          working with international companies like KE, Mountain Kingdom, and Hauser.
        </li>
      </ol>
    </p>
    <p>
      All of this is possible because HoneyGuide can provide you with:
      <ol>
        <li>A digital platform to manage lodge, and flight bookings directly.</li>
        <li>A huge pool of the best trekking guides in the industry to choose from.</li>
        <li>Get prices directly from the Local Service Providers.</li>
        <li>Complete ground support for your clients.</li>
      </ol>
    </p>
    <p>Sign Up to Run your Treks in a Better Way</p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha <br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSc5k51I2wS5cwm2LPMy7viDT6hlJFNgVm5N6oJW8gIpAp_MCQ/viewform?embedded=true"
      width="100%"
      height="1078"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Travel Agent"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default TravelAgent;



// WEBPACK FOOTER //
// ./src/screens/Partners/TravelAgent.jsx